import React, { useState, useEffect, useRef } from 'react'
import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ExpectedResultPanel from '../../../widgets/projectProposal/expectedresult/ExpectedResult'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProjectExpectedResult } from '../../../redux/actions/ProjectExpectedResult'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { useSelector } from 'react-redux'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function ExpectedResult() {
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [error, setError] = useState()
  const [isEditWidget, setIsEditWidget] = useState({})
  const [showEditAll, setShowEditAll] = useState()
  
  const previousPanelRef = useRef(null)
  const projectId = sessionStorage.getItem('projectId')

  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.granteeBasicInfo}`,
    pathNameForward: `${pathname.proposal.monitoringAndInternalEvaluation}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  useEffect(() => {
    if (isViewPrevious && schemaPrevious) {
      previousPanelRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [isViewPrevious, schemaPrevious])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectExpectedResult(proposalId)
      setSchema(_schema)
      setIsEditWidget({
        expected:
          _schema?.forms?.expectedResult?.expectedWay?.value?.length > 0 &&
          _schema?.forms?.expectedResult?.expectedResult?.value?.length > 0
            ? false
            : true,
      })
      
      const canEdit = _schema?.forms?.expectedResult && !_schema?.forms?.expectedResult.disabled
      setShowEditAll(canEdit)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getProjectExpectedResult(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 ก้อนที่ 1: จับข้อมูล "เวอร์ชันปัจจุบัน" มัดรวมไว้ในตัวแปรนี้ จะได้ไม่ต้องเขียนโค้ดซ้ำ 2 รอบ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.expectedResult && (
        <>
          <ExpectedResultPanel
            showCommandButton={!schema.forms.expectedResult.disabled}
            schema={schema?.forms?.expectedResult}
            isEdit={isEditWidget.expected}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('expected', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon 
        handleGetSchemaPrevious={handleGetSchemaPrevious} 
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1028,5-5013'}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper">
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <div ref={previousPanelRef}>
            <div className="line" />
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ก่อนหน้า'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed'  }}
            >
              <div className="bottom">
                {schemaPrevious?.forms?.expectedResult && (
                  <>
                    <ExpectedResultPanel
                      showCommandButton={false}
                      schema={schemaPrevious.forms.expectedResult}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}
              </div>
            </Panel>
            <br />
            <br />
          </div>
        )}
      </div>
    </SidebarProposal>
  )
}
